import TagManager from 'react-gtm-module';
import { isWebBridgeSupported } from '@shopee/web-bridge-sdk';
import { BusinessTarget, BusinessTargetConfig } from '@shopee-user/global';

let isGtmInitialized = false;

const getGtmId = () => {
  return (
    BusinessTargetConfig[__BUSINESS_TARGET__ as BusinessTarget].gtmId || ''
  );
};

// This is a workaround for the GTM is not enabled for all business lines
// We need this since GTM will injects some scripts, it can slow down the page load
// Now the GTM is not needed for all business lines, so we can use this toggle to control it
// Why we can not use the feature toggle directly?
// Because platform interface will be imported by `@shopee-user/business-customization-logic` packages, it will cause a circular dependency
// We will need to have some platform feature toggle that will be controlled by tob-web app level
// TODO @tranct @jay.liang implement feature toggle for GTM at platform level or move the static feature toggle to `@shopee-user/platform`
const isGtmEnabled = () => {
  return (
    [BusinessTarget.Spx].includes(__BUSINESS_TARGET__ as BusinessTarget) &&
    !isWebBridgeSupported() // We disable the GTM JS in web since it will be send by the native app
  );
};

/**
 * We can initialize GTM
 * We have to call initGtm first
 */
const initGtm = () => {
  if (!isGtmEnabled) {
    // No warning will be displayed here since it is OK that some product lines do not have GTM
    return;
  }

  const gtmId = getGtmId();
  if (gtmId) {
    isGtmInitialized = true;
    TagManager.initialize({ gtmId });
  } else {
    console.warn(
      'GTM id is not set. Please set the GTM ID in the BusinessTargetConfig'
    );
  }
};

/**
 * We can push data to GTM data layer
 * If the GTM is not enabled or not initiaglized, it will not do anything (no-op)
 * This is useful for tracking events
 * We have to call initGtm first
 */
const pushGtmEvent = (event: Record<string, any>) => {
  if (!isGtmEnabled()) {
    // No warning will be displayed here since it is OK that some product lines do not have GTM
    // This is not a bug so we do not log it
    return;
  }

  if (!isGtmInitialized) {
    console.warn(
      'GTM is not initialized. Please call initGtm first before pushing GTM event'
    );
    return;
  }

  TagManager.dataLayer({
    dataLayer: event,
    dataLayerName: 'dataLayer',
  });
};

export const Gtm = {
  init: initGtm,
  pushEvent: pushGtmEvent,
};
